// extracted by mini-css-extract-plugin
export var wrapper = "BlogList-module--wrapper--2HsET";
export var container = "BlogList-module--container--1fcth";
export var layout = "BlogList-module--layout--2qL9X";
export var hasSidebar = "BlogList-module--hasSidebar--WoH4l";
export var preview = "BlogList-module--preview--BbaWd";
export var moreLink = "BlogList-module--moreLink--1ZW7A";